<script lang="ts">
    import { Splide, SplideSlide } from "@splidejs/svelte-splide"
    import { onMount } from "svelte"

    import "@splidejs/svelte-splide/css"

    import MedialibImage from "./MedialibImage.svelte"
    import ThumbnailSlidesSlide from "./ThumbnailSlides_Slide.svelte"
    import { apiBaseOverride } from "../store"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let slides: BlockThumbnailSlide[]

    let main: Splide
    let nav: Splide

    onMount(() => {
        if (main && nav) {
            main.sync(nav.splide)
        }
    })
</script>

<!--
        Hero Slider
        - mit und ohne Kategorie (Dropdown-Feld)
          Kategorien: orienteering, mtb-enduro, school-sports, other-sports
        - Muss als Slider funktionieren! (Svelte)
        - Bild links oder Bild rechts (entscheidbar über Dropdown)
        
    -->

<section class="hero">
    {#if slides?.length}
        <div class="slider-with-nav">
            {#if slides?.length > 1}
                <div class="slider-nav col-md-3 col-bleed hidden-sm-down" data-num-slides="{slides?.length}">
                    <Splide
                        bind:this="{nav}"
                        options="{{
                            type: 'slide',
                            rewind: true,
                            pagination: false,
                            isNavigation: true,
                            updateOnMove: true,
                            direction: 'ttb',
                            height: '624px',
                            autoHeight: true,
                            heightRatio: 0.3,
                            gap: '2px',
                        }}"
                        aria-label="..."
                    >
                        {#each slides || [] as slide}
                            <!-- is admin view or not hidden -->
                            {#if apiBase || !slide.hide}
                                <SplideSlide>
                                    <div class="slide" class:hidden="{!!slide.hide}">
                                        {#if slide.backgroundImage}
                                            <div class="background-image">
                                                <img
                                                    class="background-detail"
                                                    src="/assets/img/products-detailheader.jpg"
                                                    alt="Product Detail"
                                                />
                                                <figure>
                                                    <MedialibImage id="{slide.backgroundImage}" filter="l" />
                                                    <!-- Wir kriegen für alle Slides ein Hintergrundbild und ein Content-Bild (s.u.) -->
                                                </figure>
                                            </div>
                                        {/if}
                                    </div>
                                </SplideSlide>
                            {/if}
                        {/each}
                    </Splide>
                </div>
            {/if}
            <div class="slider col-bleed" data-num-slides="{slides?.length}" class:col-md-9="{slides?.length > 1}">
                <Splide
                    bind:this="{main}"
                    options="{{
                        type: 'loop',
                        pagination: false,
                        rewind: true,
                        perMove: 1,
                    }}"
                >
                    {#each slides || [] as slide}
                        <!-- is admin view or not hidden -->
                        {#if apiBase || !slide.hide}
                            <SplideSlide>
                                <img
                                    class="background-detail"
                                    src="/assets/img/products-detailheader.jpg"
                                    alt="Product Detail"
                                />
                                <ThumbnailSlidesSlide {apiBase} {slide} />
                            </SplideSlide>
                        {/if}
                    {/each}
                </Splide>
            </div>
        </div>
    {/if}
</section>

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
    .background-detail {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
    }
</style>
